<template>
  <div>
    <div class="app-head">
      <div>
        <h4 class="app-title">机构学习资源</h4>
        <div class="app-desc">管理发布的学习资源。</div>
      </div>
      <div>
        <router-link to="/course-edit">发布新学习资源</router-link>
      </div>
    </div>
    <div class="app-form">
      <div class="course">
        <el-alert v-if="!list.length" type="error" :closable="false">~还没有发布学习资源</el-alert>
        <el-card v-for="item in list" :key="item.id" :body-style="{ padding: '0px' }" class="course-item">
          <div class="course-box">
            <el-image :src="rootPath + item.pic" fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="content">
              <h4><a :href="rootPath +'organization/course/'+ item.id" target="_blank">{{ item.title }}</a></h4>
              <div class="detail">
                <time class="time">{{ item.createtime }}</time>
                <span class="ml-4">分类：{{ item.catename }}</span>
                <span class="ml-4">教师：{{ item.teacher }}</span>
                <span class="ml-4">学时：{{ item.minute }} 分钟</span>
              </div>
              <div class="ellipsis-2 desc">{{ showContent(item) }}</div>
            </div>
            <div class="btns">
              <div class="mb-2">状态：<jy-badge :type="CheckStatusType(item)">{{ check[item.status +''] }}</jy-badge></div>
              <div v-if="item.status != 2" class="mb-2">
                <el-button v-if="!item.status" type="primary" size="small" @click="doCheck(item, 0)">提交审核</el-button>
                <el-button v-if="item.status == 1 || item.status == 3" type="warning" size="small" @click="doCheck(item, 1)">取消审核</el-button>
                <el-button v-if="item.status == 999" type="success" size="small" @click="doCheck(item, 2)">恢复</el-button>
              </div>
              <div>
                <el-button type="success" size="small" @click="doEdit(item)">编辑</el-button>
                <el-button type="danger" size="small" @click="doDel(item)">删除</el-button>
              </div>
            </div>
          </div>
        </el-card>
        <div class="course-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import { CheckStatusType } from '@/business/mixin/global';
export default {
  mixins: [tools],
  components: {  },
  data () {
    return {
      loading: false,
      page: 1,
      total: 0,
      list: [],
    }
  },
  computed: {
    ...mapGetters({
      check: [types.STATUS.check],
      reloadCourse: [types.ORGANIZATION.reloadCourse]
    }),
  },
  watch: {
    reloadCourse() {
      this.loadData();
    }
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.list.length) {
      this.loadData();
    }
    if (!this.check || !Object.keys(this.check).length) {
      this.$store.dispatch(types.STATUS.check);
    }
  },
  methods: {
    loadData() {
      if (this.loading || !this.hasPermiss('weborg.course.query')) {
        return;
      }
      this.loading = true;
      this.doPost({
        url: 'vue/organization/course',
        data: Object.assign({page: this.page}, this.searchData),
        okcb: (json) => {
          this.list = json.list;
          this.page = json.pageNumber;
        },
        cb: () => {
          this.$nextTick(() => this.loading = false);
        }
      });
    },
    showContent(data) {
      let content = data.content;
      if (content) {
        content = content.replace(/<\/?.+?\/?>/g, '');
      }
      return content;
    },
    CheckStatusType(data) {
      return CheckStatusType(data.status);
    },
    doEdit(data) {
      this.$router.push('/course-edit/'+ data.id);
    },
    doDel(data) {
      this.msgbox('确定要删除该资源吗？', () => {
        this.doPost({
          url: 'vue/organization/course/del/'+ data.id,
          okcb: () => {
            this.$message.success('删除成功！');
            this.list.splice(this.list.indexOf(data), 1);
          },
          cb: () => {
  
          }
        });
      });
    },
    doCheck(data, type) {
      let types = {0: '提交审核', 1: '取消审核', 2: '恢复'};
      this.msgbox(`确定要${types[type]}该资源吗？`, () => {
        this.doPost({
          url: 'vue/organization/course/check/'+ data.id +'-'+ type,
          okcb: (json) => {
            this.$message.success('操作成功！');
            data.status = json.status;
          },
          cb: () => {
  
          }
        });
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    margin-bottom:2rem;
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
}
.course {
  &-item {
    margin-bottom:2rem;
    /deep/ .course-box {
      padding:1rem;
      .flex();
      .el-image {
        width:22%;
        margin-right:1.5rem;
      }
      .content {
        flex-grow:1;
      }
      .detail {
        .flex-center-v();
      }
      .desc {
        margin-top:.5rem;
        color:#666;
      }
    }

  }
  &-pagination {
    margin-top:2rem;
    .flex-center();
  }
}
</style>